import ApiService from "@/common/api.service";
import JwtService from "@/common/jwt.service";

// action types
export const VERIFY_AUTH = "verifyAuth";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REFRESH_AUTH = "refreshAuth";
export const REGISTER = "register";
export const UPDATE_USER = "updateUser";

// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_ERROR = "setError";

const state = {
  errors: null,
  user: {},
  isAuthenticated: !!JwtService.getToken(),
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
};

const actions = {
  [LOGIN](context, credentials) {
    return new Promise((resolve) => {
      let formData = new FormData();
      formData.set("username", credentials.username);
      formData.set("password", credentials.password);
      ApiService.post("token", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(({ data }) => {
          context.commit(SET_AUTH, { ...data, username: credentials.username });
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.detail]);
        });
    });
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH);
  },
  [REFRESH_AUTH](context) {
    return new Promise((resolve, reject) => {
      const refreshToken = JwtService.getRefreshToken();
      if (!refreshToken) {
        reject(new Error("No refresh token"));
        return;
      }

      let formData = new FormData();
      formData.set("grant_type", "refresh_token");
      formData.set("refresh_token", refreshToken);
      ApiService.refreshToken(formData)
        .then(({ data }) => {
          context.commit(SET_AUTH, {
            ...data,
            username: context.state.user.username,
          });
          resolve(data);
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            context.commit(PURGE_AUTH);
          }
          reject(error);
        });
    });
  },
  [REGISTER](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.post("users", { user: credentials })
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.detail]);
          reject(response);
        });
    });
  },
  [VERIFY_AUTH](context) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.get("token", "verify")
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
        })
        .catch(({ response }) => {
          if (!response) return;

          if (response.data) context.commit(SET_ERROR, [response.data.detail]);

          context.commit(PURGE_AUTH);
        });
    } else {
      context.commit(PURGE_AUTH);
    }
  },
  [UPDATE_USER](context, payload) {
    const { email, username, password, image, bio } = payload;
    const user = { email, username, bio, image };
    if (password) {
      user.password = password;
    }

    return ApiService.put("user", user).then(({ data }) => {
      context.commit(SET_AUTH, data);
      return data;
    });
  },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_AUTH](state, user) {
    const { refresh_token: refreshToken, ...rest } = user;
    state.isAuthenticated = true;
    state.user = rest;
    state.errors = {};
    JwtService.saveToken(state.user.access_token);
    if (refreshToken) {
      JwtService.saveRefreshToken(refreshToken);
    }
    ApiService.setHeader();
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
    JwtService.destroyToken();
    JwtService.destroyRefreshToken();
    ApiService.clearHeader();
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
